import { useState, useEffect } from "react";
import axios from "axios";
import { PieChart, Pie, Cell } from "recharts";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL 
  
  const COLORS = ["#F2A93B", "#3F7D20", "#a70707ff"];
  
const AgricPieChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/value-chain`)
      .then((response) => {
        const res = response.data;
        if (!res.success) return;
        const yes = res.yesDefinitely ?? 0;
        const maybe = res.maybe ?? 0;
        const no = res.no ?? 0;
        const total = yes + maybe + no;
        const toPercent = (n) =>
          total > 0 ? Math.round((n / total) * 1000) / 10 : 0;
        setData([
          { name: "Yes, Definitely", value: toPercent(yes), count: yes },
          { name: "Maybe Interested", value: toPercent(maybe), count: maybe },
          { name: "Not Interested", value: toPercent(no), count: no },
        ]);
      })
      .catch((error) => console.error("Error fetching value chain stats:", error));
  }, []);

  const hasData = data.length > 0;
  const chartData = hasData ? data : [{ name: "No data", value: 1 }];

  return (
    <div className="block justify-center">
      <PieChart width={220} height={220} className="mx-auto">
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          outerRadius={90}
          dataKey="value"
        >
          {chartData.map((_, index) => (
            <Cell
              key={index}
              fill={hasData ? COLORS[index % COLORS.length] : "#e5e7eb"}
            />
          ))}
        </Pie>
      </PieChart>
      <div className="block justify-center gap-6 mt-4 text-sm ">
        {hasData ? (
          data.map((item) => (
            <div key={item.name} className="flex items-center gap-2">
              <span
                className="h-4 w-4 rounded"
                style={{
                  backgroundColor:
                    item.name === "Yes, Definitely"
                      ? "#F2A93B"
                      : item.name === "Maybe Interested"
                        ? "#3F7D20"
                        : "#a70707ff",
                }}
              />
              {item.name} {item.count.toLocaleString()} {item.value}%
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">No data yet.</p>
        )}
      </div>
    </div>
  );
};

export default AgricPieChart;
